import { defineMessages } from '@transcend-io/internationalization';

export const policyVersionsMessages = defineMessages(
  'privacy-center.components.PolicyVersions.policyVersions',
  {
    pastVersions: {
      defaultMessage: 'View Past Versions',
    },
    changes: {
      defaultMessage: 'Changes',
    },
  },
);
